import { render } from "./Centres.vue?vue&type=template&id=7c05cd95&scoped=true"
import script from "./Centres.vue?vue&type=script&lang=js"
export * from "./Centres.vue?vue&type=script&lang=js"

import "./Centres.vue?vue&type=style&index=0&id=7c05cd95&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c05cd95"]])

export default __exports__